/**
 * Front-end behavior for Logo Bar (scoped to block instances).
 */
export class LogoBarFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="logo-bar"]' ).forEach( ( el ) => {
			el.classList.add( 'logo-bar-enhanced' );
		} );
	}
}
